import { useTranslation } from "react-i18next";

import { getBuildingById, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";
import { IconButton } from "@molecules";

import { useHaNLayoutMode } from "../state/layout/useHaNLayoutMode";
import { HaNContext } from "./HaNContext";
import { useOpenBuildingPicker } from "./useOpenBuildingPicker";

// The sidebar's title bar on wide screens; the app header row on phones, with the map/list toggle
export const HaNHeader = () => {
  const { t } = useTranslation();
  const { building, mobileView } = useRequiredContext(HaNContext);
  const layoutMode = useHaNLayoutMode();
  const buildingName = useAppSelector(state => getBuildingById(state, building.buildingId ?? ""))?.name;
  const openBuildingPicker = useOpenBuildingPicker();

  const showsMobileViewToggle = layoutMode === "mobile" && mobileView.canToggle;
  const isListView = mobileView.view === "list";

  return (
    <header className="col-start-1 row-start-2 flex h-[60px] items-center justify-between gap-2 border-b border-r bg-white px-5 max-sm:row-start-1 max-sm:justify-start max-sm:border-r-0 max-sm:px-4">
      <h1 className="truncate text-[17px] font-semibold leading-6 max-sm:font-display max-sm:text-[26px] max-sm:font-medium max-sm:leading-8">
        {buildingName}
      </h1>
      {openBuildingPicker && (
        <IconButton
          aria-label={t("translation:Building")}
          icon="caretDown"
          iconButton="tertiary"
          size="small"
          onClick={openBuildingPicker}
        />
      )}
      {showsMobileViewToggle && (
        <IconButton
          className="ml-auto"
          aria-label={isListView ? t("hereAndNow:Map") : t("hereAndNow:ListOfRooms")}
          icon={isListView ? "map" : "weekView"}
          iconButton="tertiary"
          onClick={mobileView.toggleView}
        />
      )}
    </header>
  );
};
